module.exports = __webpack_public_path__ + "img/paris-saint-germain.021a8ea2.png";